// extracted by mini-css-extract-plugin
export var content = "_nz-1";
export var noScroll = "_nz-3";
export var paper = "_nz-0";
export var scrollable = "_nz-2";